import { categories } from "@/mocks/categories";

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Artistic%20fashion%20editorial%20photography%20with%20minimalist%20sneakers%20and%20oversized%20hoodie%20on%20clean%20concrete%20surface%2C%20soft%20natural%20light%20from%20left%20side%2C%20cream%20and%20beige%20tones%2C%20shallow%20depth%20of%20field%2C%20organic%20texture%2C%20european%20streetwear%20aesthetic%2C%20editorial%20fashion%20magazine%20style%2C%20warm%20neutral%20backdrop%2C%20high%20end%20product%20photography%20with%20subtle%20grain%20texture&width=1800&height=1200&seq=hero-bg-main&orientation=landscape"
        alt="GTBuy Sheet fashion editorial"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/50"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <p className="text-white/70 text-xs md:text-sm tracking-[0.2em] uppercase mb-4 md:mb-6 font-label">
          Smart Shopping Starts Here
        </p>
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-white leading-none mb-3 md:mb-4">
          GTBUY SHEET
        </h1>
        <p className="text-xl md:text-2xl lg:text-3xl font-heading italic text-white/90 mb-4 md:mb-6">
          Curated for US &amp; EU
        </p>
        <p className="text-white/70 text-sm md:text-base max-w-lg mx-auto leading-relaxed mb-6 md:mb-8">
          Compare prices across GTBuy, Kakobuy, and Superbuy in real time. Find the best deals on fashion,
          accessories, and lifestyle products — all in one beautifully organized spreadsheet.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto whitespace-nowrap px-8 py-3 md:px-10 md:py-3.5 bg-white text-foreground-950 font-label font-semibold text-sm md:text-base rounded-full hover:bg-white/90 transition-all duration-300 cursor-pointer"
          >
            gtb<span className="lowercase">uy sheet</span>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto whitespace-nowrap px-8 py-3 md:px-10 md:py-3.5 bg-primary-500 text-white font-label font-semibold text-sm md:text-base rounded-full hover:bg-primary-600 transition-all duration-300 cursor-pointer"
          >
            buy it now
          </a>
        </div>

        <div className="mt-10 md:mt-14">
          <p className="text-white/50 text-xs uppercase tracking-widest mb-4 font-label">
            Jump to Category
          </p>
          <div className="relative inline-block w-full max-w-sm">
            <select
              className="w-full appearance-none bg-white/10 backdrop-blur-md border border-white/20 text-white rounded-full px-5 py-3 pr-12 text-sm font-label cursor-pointer focus:outline-none focus:border-white/40 transition-all hover:bg-white/15"
              onChange={(e) => {
                const url = e.target.value;
                if (url) window.open(url, "_blank", "noopener,nofollow");
              }}
              defaultValue=""
            >
              <option value="" disabled className="text-foreground-950">
                Select a category...
              </option>
              {categories.map((cat) => (
                <option key={cat.seq} value={cat.url} className="text-foreground-950">
                  {cat.name}
                </option>
              ))}
            </select>
            <i className="ri-arrow-down-s-line absolute right-4 top-1/2 -translate-y-1/2 text-white/70 pointer-events-none text-lg"></i>
          </div>
        </div>
      </div>
    </section>
  );
}